/* eslint-disable @typescript-eslint/naming-convention */

/** There is no need to add english translations, unless key-value are not the same */
import en_us from './en'
import { localizedPathname, resolvePanelLocale } from './locale'

const fa_ir: { [key: string]: string } = require('./fa.json')

export const lang = resolvePanelLocale(window.location.pathname)

const directions = {
  fa: 'rtl',
  en: 'ltr'
}

export function getDirection() {
  return directions[lang]
}

const translate = {
  fa: fa_ir,
  en: en_us
}

export function getTranslate(
  text: string,
  variables?: { [key: string]: string | number }
) {
  let translated = translate[lang][text] || text

  if (variables) {
    Object.keys(variables).forEach((key) => {
      const reg = new RegExp(`{${key}}`, 'g')
      // Replaced via a FUNCTION, not a string. As a string argument, `replace` interprets
      // `$&`, `` $` ``, `$'`, `$$` and `$<name>` as substitution patterns, so a value
      // containing them rewrites the template around itself: a promotion named
      // "Evil$`$&$'Promo" turned "Applied promotion: {names}" into
      // "Applied promotion: EvilApplied promotion: {names}Promo".
      //
      // Harmless while every caller passed system-controlled ids and counts; the booking
      // details caption is the first to pass operator-authored free text. A replacer
      // function receives no special-token treatment, which fixes it for every caller
      // rather than escaping at one call site.
      translated = translated.replace(reg, () => String(variables[key]))
    })
  }

  return translated
}

const fonts = {
  fa: 'IRANSans',
  en: 'Nunito'
}

export function getFont() {
  return fonts[lang]
}

export function changeLang(newLang: string) {
  if (newLang !== 'en' && newLang !== 'fa') {
    return
  }
  if (newLang === lang) {
    return
  }
  try {
    localStorage.setItem('lang', newLang)
  } catch {
    // Persistence is optional (private/blocked storage). Still honour this choice
    // through the URL; do not make browser storage a prerequisite for switching.
  }
  const { pathname, search, hash } = window.location
  window.location.assign(
    `${localizedPathname(pathname, newLang)}${search}${hash}`
  )
}

export const languagesList = [
  {
    key: 'EN',
    value: 'English'
  },
  {
    key: 'FA',
    value: 'فارسی'
  },
  {
    key: 'AR',
    value: 'العربية'
  }
]

/**
 * The canonical form of a language code.
 *
 * The two sides of `regionalSettings.languagesAvailable` disagree about case and
 * always have. The panel writes uppercase — `userSetting` builds its options from
 * `languagesList` above, whose keys are `EN` / `FA` / `AR`. IAM stores whatever it
 * was given, and users predating the panel owning this field hold lowercase: on
 * stage, 11 of 16 users have `["en"]` or `["fa","en"]`.
 *
 * Every read compared with `===` or `.includes()` against an uppercase literal, so
 * for those users the panel behaved as though they had no languages at all.
 *
 * It lives here rather than beside the credential helpers because it is a property
 * of the language list, not of the user — and both the credential readers and the
 * user-edit form need it.
 */
export function normalizeLanguageCode(code: string): string {
  return (code || '').trim().toUpperCase()
}

/**
 * Case-insensitive on purpose — see `normalizeLanguageCode`. An exact-case lookup
 * returned `undefined` for a stored `"en"`, which rendered a menu entry with no
 * text: the empty white box reported from stage.
 */
export function getLangLabel(input: string) {
  const key = normalizeLanguageCode(input)
  const response = languagesList.find((item) => item.key === key)

  return response?.value
}
